import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../providers/withRouter";
import { BsSearch } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import { filterAAFFs, listAAFFs, getChildrenAaffs  } from "../../services";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { UsuarioContext } from "../../providers/userContext";
import {
  getAllConsultores,
  listCosultor,
  getConsultores,
} from "../../services";
import {
  ordenarNombreYApellido,
  orderArray,
  ordenarProvinciasYMunicipios,
} from "../../functions/ordenarListas";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import {
  cambiarFormatoNombre,
  municipiosIniciales,
} from "../../functions/funciones";
import SearchProgresState from "./SearchProgresState";
import { useLocation } from "react-router-dom";

const FiltrosGestion = ({
  onFilter,
  clearFilter,
  filtrosIniciales,
  ocultarAaff,
  ocultarFiltroAaff,
  clean,
  serviceCounts
}) => {
  const { t } = useTranslation('common');
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [aaff, setAAFF] = useState([]);
  const [oficinas, setOficinas] = useState([]);

  const user = useContext(UsuarioContext);

  const esSafari = () => {
    const ua = navigator.userAgent;
    return /iPad|iPhone|iPod/.test(ua);
  };

  const [typeInicio, setTypeInicio] = useState(esSafari() ? "date" : "text");
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [typeFin, setTypeFin] = useState(esSafari() ? "date" : "text");
  const [consultor, setConsultor] = useState([]);
  const varEstados = JSON.parse(localStorage.getItem("states")) || [];
  const varGrupos = JSON.parse(localStorage.getItem("groups")) || [];
  const [estado, setEstado] = useState([]);
  const [sinConsul, setSinConsul] = useState(false);
  const [consultorCambiado, setConsultorCambiado] = useState(false);
  const location = useLocation();
 
  const [availCai, setAvailCai] = useState(false);
  const [availKae, setAvailKae] = useState(false);
  useEffect(() => {
    if (serviceCounts?.cai > 0) setAvailCai(true);
    if (serviceCounts?.kae > 0) setAvailKae(true);
  }, [serviceCounts?.cai, serviceCounts?.kae]);

  useEffect(() => {
    cargarUser();
    getDatas();
    if (localStorage.getItem("hasReloaded") === "true") {
      clearAllFilters();
      cargarUser();
      localStorage.setItem("hasReloaded", "false");
    }
  }, [localStorage.getItem("states"), localStorage.getItem("groups"), location, availCai, availKae]);

  const handleFocusInicio = () => !esSafari() && setTypeInicio("date");
  const handleBlurInicio = () => {
    if (!esSafari() && !busqueda.fechaAltaInicio) setTypeInicio("text");
  };
  const handleFocusFin = () => !esSafari() && setTypeFin("date");
  const handleBlurFin = () => {
    if (!esSafari() && !busqueda.fechaAltaFin) setTypeFin("text");
  };
  const getDatas = async () => {
    const estados = JSON.parse(localStorage.getItem("states")) || [];
    const grupos = JSON.parse(localStorage.getItem("groups")) || [];

    const ordenGrupos = ["CAE", "LOPD", "CAI", "KAE"];
    const numEstados = estados.length || 5;
    // CAI y KAE solo admiten estos estados; CAE y LOPD los muestran todos.
    const estadosReducidos = ["Activa", "Baja", "Anulado"];
    const gruposReducidos = ["CAI", "KAE"];
   
    const esAaff = user.rol === "AAFF";
    const mostrarGrupo = (nombre) => {
      if (!esAaff) return true;
      if (nombre === "CAI") return !!user.esProvinciasCai && availCai;
      if (nombre === "KAE") return !!user.esCataluna && availKae;
      return true;
    };
    
    const listado = ordenGrupos.flatMap((nombre, gi) => {
      const grupo = grupos.find(g => g.nombre === nombre);
      if (!grupo) return [];
      if (!mostrarGrupo(nombre)) return [];
      return estados
        .map((estado, ei) => ({
          id: gi * numEstados + ei + 1,
          grupo: grupo.nombre,
          estadoNombre: estado.nombre,
          nombre: `${grupo.nombre} - ${estado.nombre}`,
        }))
        .filter(
          (item) => !gruposReducidos.includes(grupo.nombre) || estadosReducidos.includes(item.estadoNombre)
        );
    });
    if(user.rol === "ADMIN_CAI"){
      const soloCai = listado.filter(item => item.grupo === "CAI");
      setEstado(soloCai);
    }else{
      setEstado(listado);
    }

    const consul =
      user.rol === "CONSUL"
        ? await getConsultores({ filtros: { id: user.id } })
        : [];

    // CORREGIDO: Solo establecer el consul_id si no ha sido cambiado manualmente
    if (user.rol === "CONSUL" && consul.data?.length > 0) {
      if (!consultorCambiado) {
        setBusqueda((prevBusqueda) => ({
          ...prevBusqueda,
          consul_id: user.id,
        }));
      }

      setConsultor(ordenarNombreYApellido(consul.data));
    }

    if (user.rol === "AAFF" && user.parent === true) {
      const oficinasResponse = await getChildrenAaffs(user.id, {
        filtros: {},
        params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
      });
      if (oficinasResponse?.data) {
        const oficinasPadre = {
          id: user.id,
          razonSocial: user.razonSocial || user.nombre || "Oficina Principal",
          nif: user.nif
        };
        setOficinas([oficinasPadre, ...oficinasResponse.data]);
      }
    }
  };

  // const getDatas = async () => {

  //   const estados = await getEstadosFincas();
  //   const prefijos = await getServicesPropsGroup();

  //   const listado = prefijos.flatMap((grupo, index) =>
  //     estados .map((estado, i) => ({
  //       id: index * estados.length + i + 1,
  //       nombre: `${grupo.nombre} - ${estado.nombre}`
  //     }))
  //   );
  //   console.log("listado", listado);
  //   setEstado(listado);
  //   const consul =
  //     user.rol === "CONSUL"
  //       ? await getConsultores({ filtros: { id: user.id } })
  //       : [];

  //   if (user.rol === "CONSUL" && consul.data?.length > 0) {
  //     setBusqueda({
  //       ...busqueda,
  //       consul_id: user.id,
  //     });

  //     setConsultor(ordenarNombreYApellido(consul.data));
  //   }
  // };

  useEffect(() => {
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, busqueda.provincia)
    );
  }, [busqueda]);

  // useEffect(() => {
  //   cargarUser();
  // }, []);

  const cargarUser = () => {
    if (user.rol === "CONSUL" && !sinConsul && !consultorCambiado) {
      setBusqueda((prevBusqueda) => ({
        ...prevBusqueda,
        consul_id: user.id,
      }));
    }
    localStorage.setItem("hasReloaded", "false");
  };

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {
      clearAllFilters();
      cargarUser();
      localStorage.setItem("hasReloaded", "false");
    }
  }, [location]);

  const clearAllFilters = () => {
    setSinConsul(false);
    setConsultorCambiado(false);
    setBusqueda({});
    setOficinas([]);
    setTypeInicio(esSafari() ? "date" : "text");
    setTypeFin(esSafari() ? "date" : "text");
    clearFilter();
    cargarUser();
  };

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.map((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    if (e.target.name === "provincia" || e.target.value === "") {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
        municipio: "",
      });
    } else {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
      });
    }
    municipalities.map((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  const handleAsynchronousChange = async (name, selectedValue) => {
    if (name === "consul_id") {
      setConsultorCambiado(true);
    }

    // Si se selecciona un AAFF, cargar sus oficinas (hijos)
    if (name === "aaff_id") {
      if (selectedValue?.id) {
        const oficinasResponse = await getChildrenAaffs(selectedValue.id, {
          filtros: {},
          params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
        });
        if (oficinasResponse?.data && oficinasResponse.data.length > 0) {
          setOficinas(oficinasResponse.data);
        } else {
          setOficinas([]);
        }
      } else {
        setOficinas([]);
      }
      // Limpiar oficina seleccionada cuando cambia el AAFF
      setBusqueda({
        ...busqueda,
        [name]: selectedValue?.id,
        oficina_id: undefined,
      });
      return;
    }

    setBusqueda({
      ...busqueda,
      [name]: selectedValue?.id,
    });
  };

  const busquedaInput = (name, valorBusqueda) => {
    if (
      name === "aaff_id" &&
      user.rol !== "AAFF" &&
      (busqueda.aaff_id !== undefined || valorBusqueda)
    ) {
      listAAFFs({
        filtros: {
          razonSocial: valorBusqueda,
          excludeChildren: true,
        },
        params: {},
      }).then((res) => {
        setAAFF(orderArray(res.data));
      });
    }

    if (
      name === "consul_id" &&
      user.rol !== "AAFF" &&
      (busqueda.consul_id !== undefined || valorBusqueda)
    ) {
      listCosultor({
        filtros: {
          nombreA: valorBusqueda,
        },
        params: {},
      }).then((res) => {
        setConsultor(ordenarNombreYApellido(res.data));
      });
    }

    if (
      name === "oficina_id" &&
      user.rol === "AAFF" &&
      user.parent === true &&
      (busqueda.oficina_id !== undefined || valorBusqueda)
    ) {
      getChildrenAaffs(user.id, {
        filtros: {
          razonSocial: valorBusqueda
        },
        params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
      }).then((res) => {
        if (res?.data) {
          const oficinasPadre = {
            id: user.id,
            razonSocial: user.razonSocial || user.nombre || "Oficina Principal",
            nif: user.nif
          };

          if (valorBusqueda && user.razonSocial && !user.razonSocial.toLowerCase().includes(valorBusqueda.toLowerCase())) {
            setOficinas(res.data);
          } else {
            setOficinas([oficinasPadre, ...res.data]);
          }
        }
      });
    }

    // Búsqueda de oficinas para otros roles (cuando hay un AAFF seleccionado)
    if (
      name === "oficina_id" &&
      user.rol !== "AAFF" &&
      busqueda.aaff_id &&
      (busqueda.oficina_id !== undefined || valorBusqueda)
    ) {
      getChildrenAaffs(busqueda.aaff_id, {
        filtros: {
          razonSocial: valorBusqueda
        },
        params: { page: 1, limit: 1000, order: 'ASC', orderBy: 'razonSocial' }
      }).then((res) => {
        if (res?.data) {
          setOficinas(res.data);
        }
      });
    }
  };

  function handleChange(evt) {
    const value = evt.target.value;

    //Eliminar estadoLopd / estadoCai / estadoKae si se selecciona un estadoCae
    if (busqueda.estadoLopd) {
      delete busqueda.estadoLopd;
    }
    if (busqueda.estadoCai) {
      delete busqueda.estadoCai;
    }
    if (busqueda.estadoKae) {
      delete busqueda.estadoKae;
    }
    setBusqueda({
      ...busqueda,
      [evt.target.name]: value,
    });
  }

  const getBusqueda = () => {
    for (let key in busqueda) {
      if (
        busqueda[key] === "" ||
        busqueda[key] === null ||
        busqueda[key] === undefined
      ) {
        delete busqueda[key];
      }
    }

    if (busqueda.consul_id == undefined) {
      setSinConsul(true);
    }
    const numEstados = varEstados.length || 5;
    // como los 3 estados estan en un mismo select, al filtrar por estadoCae, estadoLopd o estadoCai, el valor que se guarda en busqueda es el mismo (estadoCae), por eso al hacer la busqueda hay que comprobar a cual de los 3 estados corresponde segun su valor y asignarlo a su propiedad correspondiente (estadoCae, estadoLopd o estadoCai) para que el backend pueda filtrar correctamente
    if (busqueda.estadoCae !== undefined && busqueda.estadoCae !== null && busqueda.estadoCae !== "") {
      delete busqueda.estadoLopd;
      delete busqueda.estadoCai;
      delete busqueda.estadoKae;
      if (Number(busqueda.estadoCae) > 3 * numEstados) {
        busqueda.estadoKae = Number(busqueda.estadoCae) - 3 * numEstados;
        delete busqueda.estadoCae;
      } else if (Number(busqueda.estadoCae) > 2 * numEstados) {
        busqueda.estadoCai = Number(busqueda.estadoCae) - 2 * numEstados;
        delete busqueda.estadoCae;
      } else if (Number(busqueda.estadoCae) > numEstados) {
        busqueda.estadoLopd = Number(busqueda.estadoCae) - numEstados;
        delete busqueda.estadoCae;
      }
    }

    onFilter(busqueda);

  };

  return (
    <>
      <div className="buscadorFiltros">
        <div style={{ width: "100%" }}>
          <Box mx={1} display={"block"} flexDirection={"row"} gap={2}>
            {!ocultarAaff && (
              <TextField
                id="nif-input"
                label={t('filters.nif')}
                variant="outlined"
                name="nif"
                className="filtros altura"
                value={busqueda.nif || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                inputProps={{
                  "aria-label": "controlled",
                }}
              />
            )}
            <TextField
              id="razonSocial-input"
              label={t('filters.businessName')}
              variant="outlined"
              name="razonSocial"
              className="filtros altura"
              value={busqueda.razonSocial || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{
                "aria-label": "controlled",
              }}
            />
            <TextField
              id="codigoPostal-input"
              label={t('filters.postalCode')}
              variant="outlined"
              name="codigoPostal"
              className="filtros altura"
              value={busqueda.codigoPostal || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{
                "aria-label": "controlled",
              }}
            />
            <TextField
              id="direccion-input"
              label={t('filters.address', { defaultValue: 'Dirección' })}
              variant="outlined"
              name="direccion"
              className="filtros altura"
              value={busqueda.direccion || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{
                "aria-label": "controlled",
              }}
            />
            {user.rol === "AAFF" && user.parent === true && (
              <FormControl variant="outlined" className="filtros-select">
                <SearchProgresState
                  labelId="oficina-label"
                  id="oficina-select"
                  label={t('filters.office')}
                  name="oficina_id"
                  className="filtros altura"
                  tipo="razonSocial"
                  array={oficinas}
                  onOptionSelected={handleAsynchronousChange}
                  busquedaInput={busquedaInput}
                  valueOnLoad={
                    oficinas.find((c) => c.id === busqueda.oficina_id) || null
                  }
                />
              </FormControl>
            )}
            {user.rol !== "AAFF" || user.rol !== "ADMIN_CAI" && (
              <>
                <TextField
                  type={typeInicio}
                  id="fechaAltaInicio-input"
                  label={t('filters.dateFrom')}
                  variant="outlined"
                  name="fechaAltaInicio"
                  className="filtros altura"
                  value={busqueda.fechaAltaInicio || ""}
                  onChange={handleChange}
                  onFocus={handleFocusInicio}
                  onBlur={handleBlurInicio}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                  InputLabelProps={esSafari() ? { shrink: true } : undefined}
                />
                <TextField
                  type={typeFin}
                  id="fechaAltaFin-input"
                  label={t('filters.dateTo')}
                  variant="outlined"
                  name="fechaAltaFin"
                  className="filtros altura"
                  value={busqueda.fechaAltaFin || ""}
                  onChange={handleChange}
                  onFocus={handleFocusFin}
                  onBlur={handleBlurFin}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                  InputLabelProps={esSafari() ? { shrink: true } : undefined}
                />
              </>
            )}
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="provincia-label">{t('filters.province')}</InputLabel>
              <Select
                labelId="comunidad-label"
                id="province-select"
                label={t('filters.province')}
                name="provincia"
                className="filtros"
                value={busqueda.provincia || ""}
                onChange={seleccionarMunicipios}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <MenuItem key={i} value={e.name}>
                      {e.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="municipio-label">{t('filters.municipalities')}</InputLabel>
              <Select
                labelId="municipio-label"
                id="municipio-select"
                label={t('filters.municipality')}
                name="municipio"
                className="filtros"
                value={busqueda?.municipio || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {listadoMunicipios
                  .sort(ordenarProvinciasYMunicipios)
                  ?.map((e, i) => {
                    return (
                      <MenuItem key={i} value={e.name}>
                        {e.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            {user.rol !== "AAFF" && user.rol !== "COMM" && (
              <>
                {!ocultarFiltroAaff && (
                  <>
                    <FormControl variant="outlined" className="filtros-select">
                      <SearchProgresState
                        labelId="aaff-label"
                        id="aaff-select"
                        label={t('filters.propertyManager')}
                        name="aaff_id"
                        className="filtros"
                        tipo="razonSocial"
                        array={aaff}
                        onOptionSelected={handleAsynchronousChange}
                        busquedaInput={busquedaInput}
                        valueOnLoad={
                          aaff.find((c) => c.id === busqueda.aaff_id) || null
                        }
                      />
                    </FormControl>
                    <FormControl variant="outlined" className="filtros-select">
                      <SearchProgresState
                        labelId="oficina-label"
                        id="oficina-select"
                        label={t('filters.office')}
                        name="oficina_id"
                        className="filtros"
                        tipo="razonSocial"
                        array={oficinas}
                        onOptionSelected={handleAsynchronousChange}
                        busquedaInput={busquedaInput}
                        valueOnLoad={
                          oficinas.find((c) => c.id === busqueda.oficina_id) || null
                        }
                        disabled={!busqueda.aaff_id || oficinas.length === 0}
                      />
                    </FormControl>
                  </>
                )}
                {user.rol !== "ADMIN_CAI" && (
                  <FormControl variant="outlined" className="filtros-select">
                    <SearchProgresState
                      labelId="consultor-label"
                      id="consultor-select"
                      label={t('filters.consultant')}
                      name="consul_id"
                      className="filtros"
                      tipo="nombre"
                      array={consultor}
                      onOptionSelected={handleAsynchronousChange}
                      busquedaInput={busquedaInput}
                      valueOnLoad={consultor.find(
                        (c) => c.id === busqueda.consul_id
                      )}
                    />
                  </FormControl>
                )}
              </>
            )}
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="estadoCaeLopd-label">{user.rol === "ADMIN_CAI" ? t('filters.stateCai') : t('filters.stateCaeLopdCai')}</InputLabel>
              <Select
                labelId="estadoCaeLopd-label"
                id="estadoCaeLopd-select"
                label={user.rol === "ADMIN_CAI" ? t('filters.stateCai') : t('filters.stateCaeLopdCai')}
                name="estadoCae"
                className="filtros"
                value={
                    busqueda.estadoKae
                    ? Number(busqueda.estadoKae) + 3 * (varEstados.length || 5)
                    : busqueda.estadoCai
                    ? Number(busqueda.estadoCai) + 2 * (varEstados.length || 5)
                    : busqueda.estadoLopd
                    ? Number(busqueda.estadoLopd) + (varEstados.length || 5)
                    : busqueda.estadoCae
                    ? Number(busqueda.estadoCae)
                    : ""
                }
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {estado.map((e, i) => {
                  return (
                    <MenuItem key={i} value={e.id}>
                      {e.grupo} - {t(`stateNames.${e.estadoNombre}`, e.estadoNombre)}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            {/* <FormControl variant="outlined" className='filtros-select'>
              <InputLabel id="estadoLopd-label">Estado LOPD</InputLabel>
              <Select
                labelId="comunidad-label"
                id="estadoLopd-select"
                label="estadoLopd"
                name="estadoLopd"
                className="filtros"
                value={busqueda.estadoLopd || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {estado?.map((e, i) => {
                  return (
                    <MenuItem key={i} value={e.id}>
                      {e.nombre}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl> */}
          </Box>
        </div>
        <div>
          <Button className="btn-buscador" onClick={clearAllFilters}>
            <ImCross />
          </Button>
        </div>
        <div>
          <Button className="btn-buscador" onClick={() => getBusqueda()}>
            <BsSearch />
          </Button>
        </div>
      </div>
      <style jsx="true">
        {`
          .btn-buscador {
            padding: 5px 10px;
            color: #ffffff;
            background-color: #92004d;
            border-radius: 4px;
            font-weight: bold;
            width: -moz-fit-content;
            width: fit-content;
            align-self: flex-end;
            border: none;
            min-width: 40px;
            height: 40px;
            margin: 5px 10px 5px;
          }
          .btn-buscador:hover {
            color: black;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
};

export default withRouter(FiltrosGestion);
